import './About.css';
import React, { useState, useEffect } from "react";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Banner from '../assets/About/silandoAbout.png';
import Flecha from '../assets/About/flechaAbout.png';
import WhatsappVerde from '../assets/Home/whatsappVerde.png'

// Importamos las secciones
import PerfilEmpresa from "./PerfilEmpresa/PerfilEmpreza.jsx";
import Cultura from "./Cultura/Cultura.jsx";
import NuevosMateriales from './NuevosMateriales/NuevosMateriales.jsx';
import ServiciosTecnicos from './ServiciosTecnicos/ServiciosTecnicos.jsx';

function About() {
    const [selectedTab, setSelectedTab] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Detectar resize y actualizar isMobile
    useEffect(() => {
        const handleResize = () => {
            const isNowMobile = window.innerWidth < 768;
            setIsMobile(isNowMobile);

            if (!isNowMobile && selectedTab === null) {
                setSelectedTab(1);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [selectedTab]);

    // Este useEffect solo corre al montar el componente
    useEffect(() => {
        if (window.innerWidth < 768) {
            setSelectedTab(null);
        }
    }, []);

    return (
        <>
            <Navbar />
            <div className="banner-container">
                <img src={Banner} alt="Banner" className="banner-image" />
            </div>

            {isMobile ? (
                <div className="accordion-container">
                    {[1, 2, 3, 4].map((num) => (
                        <div key={num} className="accordion-item">
                            <div
                                className={`accordion-title ${selectedTab === num ? 'active' : ''}`}
                                onClick={() => {
                                    const newTab = selectedTab === num ? null : num;
                                    setSelectedTab(newTab);
                                    if (newTab !== null) {
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }
                                }}
                            >
                                <img
                                    src={Flecha}
                                    alt="Flecha"
                                    className="accordion-icon"
                                />
                                <span>
                                    {num === 1 && "Perfil Empresa"}
                                    {num === 2 && "Cultura"}
                                    {num === 3 && "Nuevos Materiales"}
                                    {num === 4 && "Servicios Técnicos"}
                                </span>
                            </div>
                            {selectedTab === num && (
                                <div className="accordion-content">
                                    {num === 1 && <PerfilEmpresa />}
                                    {num === 2 && <Cultura />}
                                    {num === 3 && <NuevosMateriales />}
                                    {num === 4 && <ServiciosTecnicos />}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    <ul className="tabs-container">
                        <li className={selectedTab === 1 ? "tab active" : "tab"} onClick={() => setSelectedTab(1)}>Perfil Empresa</li>
                        <li className={selectedTab === 2 ? "tab active" : "tab"} onClick={() => setSelectedTab(2)}>Cultura</li>
                        <li className={selectedTab === 3 ? "tab active" : "tab"} onClick={() => setSelectedTab(3)}>Nuevos Materiales</li>
                        <li className={selectedTab === 4 ? "tab active" : "tab"} onClick={() => setSelectedTab(4)}>Servicios Técnicos</li>
                    </ul>

                    <div className="content-container">
                        {selectedTab === 1 && <PerfilEmpresa />}
                        {selectedTab === 2 && <Cultura />}
                        {selectedTab === 3 && <NuevosMateriales />}
                        {selectedTab === 4 && <ServiciosTecnicos />}
                    </div>
                </>
            )}
            <Footer />
            <button
                className="whatsapp-button"
                onClick={() => window.open("https://wa.me/+5491151489606", "_blank")}
            >
                <img src={WhatsappVerde} alt="WhatsApp" />
            </button>
        </>
    );
}

export default About;
